import MainLayout from "../layout";
import Page from "../page/Page";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Section } from "@vshp/ui-components";

function ProfExaminations() {
  const { t } = useTranslation();
  let title = {
    caption: t("pages.professional_examinations.title"),
  };

  return (
    <MainLayout title={title}>
      <Page title={t("pages.professional_examinations.title")} titleKey="pages.professional_examinations.title" isWidthSmall={true}>
        <Section data-key="pages.professional_examinations.text" dangerouslySetInnerHTML={{ __html: t("pages.professional_examinations.text") }}></Section>
        <Section>
          <h3>
            <Link to="it-courses">{t("pages.professional_examinations.it")}</Link>
          </h3>
        </Section>
      </Page>
    </MainLayout>
  );
}

export default ProfExaminations;
